import React from 'react'
import { withTranslation } from 'react-i18next'

const STATS = [
  { key: 'net_qualifying_sales', value: 'GHS 0.00' },
  { key: 'commission_rate', value: '-%' },
  { key: 'quiz_rounds_completed', value: 'GHS 0.00' },
  { key: 'prediction_entries', value: 'GHS 0.00' },
  { key: 'reward_ads_spend', value: 'GHS 0.00' },
  { key: 'total_charges', value: 'GHS 0.00' }
]

export default withTranslation()(function BillingSummaryRow({ t }) {
  return (
    <div className="w-full bg-background border border-border-lines rounded-2xl p-4 flex flex-col gap-4">
      <p className="text-base font-semibold text-dark-blue">{t('billing.summary.title')}</p>

      <div className="flex items-center flex-wrap">
        {
          STATS.map(({ key, value }, index) => (
            <div key={key} className={`flex-1 min-w-[140px] px-4 first:pl-0 ${index < STATS.length - 1 ? 'border-r border-dashed border-border-lines' : ''}`}>
              <p className="text-xs font-semibold text-secondary uppercase whitespace-nowrap">{t(`billing.summary.${key}`)}</p>
              <p className="text-base text-dark-blue">{value}</p>
            </div>
          ))
        }
      </div>
    </div>
  )
})
